export const getParent = (obj) =>
  obj?.parent?.slug && obj.parent.slug !== null ? `/${obj.parent.slug}` : '';
export const getParents = (parentObj) =>
  parentObj !== null &&
  getParent(parentObj) !== false &&
  getParent(parentObj.parent) !== false
    ? `${getParent(parentObj.parent)}${getParent(parentObj)}`
    : `/${getParent(parentObj)}`;
export const getPageURL = (pageObj) =>
  pageObj?.slug && pageObj.slug !== null
    ? `${getParents(pageObj)}/${pageObj.slug}`
    : `${getParents(pageObj)}`;

export const getProjectURL = ({ slug = '' }) => `/projects/${slug}`;

export const getBoxURL = (urlObj = {}) => {
  return urlObj?.project !== null
    ? getProjectURL(urlObj?.project ?? '#')
    : urlObj?.page === null
    ? urlObj?.external ?? '#'
    : getPageURL(urlObj?.page ?? '#');
};

export const getLinkTitle = (link) => {
  const sectionLink = link?.page ?? link?.project;
  return link?.display_name ?? sectionLink?.title ?? '';
};

export const getLinkDescription = (link) => {
  const description =
    link?.page?.page_description ?? link?.project?.description ?? '';
  return link?.description ?? description;
};

export const getBoxURLv2 = (urlObj = {}) => {
  const link = urlObj?.external ?? getBoxURL(urlObj);
  const anchor = urlObj?.anchor ?? '';
  return `${link}${anchor && `#${anchor}`}`;
};

export const getBoxInfo = (urlObj) => {
  return {
    description: getLinkDescription(urlObj) ?? '',
    title: getLinkTitle(urlObj),
    url: getBoxURLv2(urlObj),
  };
};
